// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__2_8_R","p0Login":"styles_p0Login__35FsB","modal":"styles_modal__pmF2p","modalContent":"styles_modalContent__D19M_"};